import { Api } from '@axiom/ui';
import type { CandidateAlertWorkFeed } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateAlertsWorkFeedApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readCandidateAlerts(candidateId: string) {
    return super.read<{ data: CandidateAlertWorkFeed[] }>({
      endpoint: `/candidates/${candidateId}/alerts/workFeed`,
      method: 'GET',
    });
  }

  async refreshCandidateAlerts(candidateId: string) {
    return super.invalidate(`/candidates/${candidateId}/alerts/workFeed`);
  }

  readCandidateAlert(candidateId: string, alertId: string) {
    return super.read<{ data: CandidateAlertWorkFeed }>({
      endpoint: `/candidates/${candidateId}/alerts/workFeed/${alertId}`,
      method: 'GET',
    });
  }

  async refreshCandidateAlert(candidateId: string, alertId: string) {
    return super.invalidate(
      `/candidates/${candidateId}/alerts/workFeed/${alertId}`
    );
  }

  async updateCandidateAlert(
    candidateId: string,
    alertId: string,
    body: Partial<CandidateAlertWorkFeed>
  ) {
    return super.write<{ data: CandidateAlertWorkFeed }>({
      endpoint: `/candidates/${candidateId}/alerts/workFeed/${alertId}`,
      body,
      method: 'PATCH',
    });
  }
}

export const CandidateAlertsWorkFeedApi = new CandidateAlertsWorkFeedApiClass();
